import { __rest } from "tslib";
import clsx from 'clsx';
import React from 'react';
import { useControlled } from '@cmpkit/hooks';
import { partitionHTMLProps } from '../utils';
export const RadioIcon = () => (React.createElement("svg", { width: '24', height: '24', viewBox: '0 0 24 24', focusable: 'false', role: 'presentation' },
    React.createElement("g", { fillRule: 'evenodd' },
        React.createElement("circle", { fill: 'currentColor', cx: '12', cy: '12', r: '6' }),
        React.createElement("circle", { fill: 'inherit', cx: '12', cy: '12', r: '2' }))));
const Radio = React.forwardRef((props, ref) => {
    const { as: Component = 'div', title, className, children, checked: checkedProp, defaultChecked, classPrefix = 'cmp-radio', tabIndex = 0, inputProps, disabled, readOnly, plaintext, inline, name, value, onChange, onClick } = props, rest = __rest(props, ["as", "title", "className", "children", "checked", "defaultChecked", "classPrefix", "tabIndex", "inputProps", "disabled", "readOnly", "plaintext", "inline", "name", "value", "onChange", "onClick"]);
    const [checked, setChecked] = useControlled({
        controlledValue: checkedProp,
        defaultValue: defaultChecked || false,
    });
    const classes = clsx(classPrefix, className, {
        [`${classPrefix}-inline`]: inline,
        [`${classPrefix}-disabled`]: disabled,
        [`${classPrefix}-checked`]: checked,
    });
    const [htmlInputProps, restProps] = partitionHTMLProps(rest);
    const handleChange = (event) => {
        if (disabled || readOnly) {
            return;
        }
        setChecked(true);
        onChange === null || onChange === void 0 ? void 0 : onChange(event);
    };
    const input = (React.createElement("span", { className: `${classPrefix}-wrapper` },
        React.createElement("input", Object.assign({}, htmlInputProps, inputProps, { ref: ref, type: 'radio', name: name, value: value, tabIndex: tabIndex, disabled: disabled, onChange: handleChange })),
        React.createElement("span", { className: `${classPrefix}-inner`, "aria-hidden": true })));
    if (plaintext) {
        return checked ? (React.createElement(Component, Object.assign({}, restProps, { className: classes }), children)) : null;
    }
    return (React.createElement(Component, Object.assign({}, restProps, { ref: ref, onClick: onClick, className: classes, "aria-checked": checked, "aria-disabled": disabled }),
        React.createElement("div", { className: `${classPrefix}-checker` }, children ? (React.createElement("label", { title: title },
            input,
            children)) : (input))));
});
Radio.displayName = 'Radio';
export { Radio };
//# sourceMappingURL=Radio.js.map